import { createUseStyles } from 'react-jss'
import { black, mediumGrey } from '../../../../../styles/const/colors'

export default createUseStyles({
  historyItem: {
    marginTop: 16,
    '& $historyDate': {
      margin: 0,
      color: mediumGrey
    },
    '& $historyText': {
      marginTop: 3,
      color: ({ isUpdated }) => (isUpdated ? black : mediumGrey)
    }
  },
  historyDate: {},
  historyText: {}
})
